import { useCallback } from 'react';
import { Button } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';

const LoadingButton = ({
    loading = false,
    type = "button",
    className,
    onClick,
    disabled,
    children,
    ...props
}) => {
    const handleClick = useCallback(
        (e) => {
            if (loading || disabled) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
            if (onClick) onClick(e);
        },
        [loading, disabled, onClick]
    );

    return (
        <Button
            {...props}
            type={type}
            className={`${className || ''}`}
            disabled={Boolean(disabled || loading)}
            aria-busy={loading || undefined}
            onClick={handleClick}>
            {children}
            {loading && (
                <Spinner
                    animation="border"
                    size="sm"
                    role="status"
                    className="ms-2">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            )}
        </Button>
    );
};

export default LoadingButton;
